export default "<p>brand-management works!</p>\r\n"